"use strict";

exports.__esModule = true;
exports.Creative = void 0;
var _StringUtils = require("../Utils/StringUtils");
var _CreativeEventHandler2 = require("../Public/CreativeEventHandler");
var _XmlNode = require("../Core/XmlNode");
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); } /*
 * COPYRIGHT 2020-2023 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */ // Imports for jsdoc
/**
* Represents a creative object.
*
* Encapsulates the data from the `<Creative>` element of a VAST document and is the base class for three types:
* - `Linear` - the creative that represents the linear portion of an advert i.e. the actual video content.
* - `NonLinear` - the creative that is usually a graphic that overlays a small portion of the advert's video and is normally clickable.
* - `Companion` - the creative that is normally presented outside the video player.
* 
*  @hideconstructor
* @see {@link CreativeEventHandler}, which this class implements
*/
var Creative = exports.Creative = /*#__PURE__*/function (_CreativeEventHandler) {
  _inheritsLoose(Creative, _CreativeEventHandler);
  function Creative(creativeData) {
    var _this;
    _this = _CreativeEventHandler.call(this) || this;

    /** @private */
    _this.advertId = creativeData.advertId ? creativeData.advertId : "";
    /** @private */
    _this.creativeId = creativeData.id ? creativeData.id : "";
    /** @private */
    _this.universalAdIds = creativeData.universalAdIds;
    /** @private */
    _this.sequence = creativeData.sequence;
    /** @private */
    _this.adParameters = creativeData.adParameters;
    /** @private */
    _this.extensions = null;
    /** @private */
    _this.nonLinear = false;
    return _this;
  }
  var _proto = Creative.prototype;
  _proto.postParse = function postParse(extensions) {
    this.extensions = extensions;
    if (this.companionExtensions) {
      for (var _iterator = _createForOfIteratorHelperLoose(this.companionExtensions.getChildren()), _step; !(_step = _iterator()).done;) {
        var ce = _step.value;
        this.extensions.addChild(ce);
      }
    }
  }

  /**
   * @return {string} the value of AdID of this Creative, as a `string`
   */;
  _proto.getAdvertIdentifier = function getAdvertIdentifier() {
    return this.advertId;
  }

  /**
   * @return {string} the value of adParameters of this Creative, as a `string`, which may be null.
   */;
  _proto.getAdParameters = function getAdParameters() {
    return this.adParameters;
  }

  /**
   * @return {XmlNode[]} the extensions for this Creative as an array of {@link XmlNode} objects or null if
   * there are no extensions.
   */;
  _proto.getExtensions = function getExtensions() {
    return this.extensions;
  }

  /**
   * @return {string} the identifier of this Creative, as a `string`
   */;
  _proto.getCreativeIdentifier = function getCreativeIdentifier() {
    return this.creativeId;
  }

  /**
   * @return {number} the sequence number of this Creative
   */;
  _proto.getSequence = function getSequence() {
    return this.sequence;
  }

  /**
   * @return {string[]} a string array of universal ad ids of this Creative
   */;
  _proto.getUniversalAdIds = function getUniversalAdIds() {
    return this.universalAdIds;
  };
  _proto.isNonLinear = function isNonLinear() {
    return this.nonLinear;
  };
  _proto.setNonLinear = function setNonLinear(nonLinear) {
    this.nonLinear = nonLinear;
  };
  _proto.setVisible = function setVisible(_visible) {
    // No-op
  };
  _proto.toString = function toString() {
    var s = "";
    s += "\n - Id:" + this.creativeId + " AdId:" + this.advertId + " Sequence:" + this.sequence;
    if (this.adParameters) {
      s += "\n - AdParameters:";
      s += "\n" + (0, _StringUtils.toIndentedString)(this.adParameters);
    }
    if (this.universalAdIds) {
      s += "\n - UniversalAdIds:";
      for (var _iterator2 = _createForOfIteratorHelperLoose(this.universalAdIds), _step2; !(_step2 = _iterator2()).done;) {
        var uai = _step2.value;
        s += "\n" + (0, _StringUtils.toIndentedString)(uai);
      }
    }
    if (this.extensions) {
      s += "\n - CreativeExtensions:";
      s += "\n" + (0, _StringUtils.toIndentedString)(this.extensions);
    }
    return s;
  };
  return Creative;
}(_CreativeEventHandler2.CreativeEventHandler);